function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}

/**
 * Parse a fraction string to a decimal number.
 * Handles: "46", "13/16", "46 13/16", "46 13/16\"", "46.8125"
 * Returns null if unparseable.
 */
export function parseFraction(str) {
  if (str == null) return null;
  const s = String(str).trim().replace(/["""]/g, '');
  if (!s) return null;

  // Pure decimal (including negative)
  if (/^-?\d+(\.\d+)?$/.test(s)) return parseFloat(s);

  // Simple fraction: 13/16
  const simpleFrac = s.match(/^(\d+)\/(\d+)$/);
  if (simpleFrac) {
    const d = parseInt(simpleFrac[2]);
    if (d === 0) return null;
    return parseInt(simpleFrac[1]) / d;
  }

  // Mixed number: 46 13/16  (space-separated)
  const mixed = s.match(/^(\d+)\s+(\d+)\/(\d+)$/);
  if (mixed) {
    const d = parseInt(mixed[3]);
    if (d === 0) return null;
    return parseInt(mixed[1]) + parseInt(mixed[2]) / d;
  }

  return null;
}

/**
 * Format a decimal back to a fraction string for display.
 * Uses 16ths as the finest denominator (standard for glass).
 * Examples: 46.8125 → "46 13/16\"", 0.5 → "1/2\"", 46.0 → "46\""
 */
export function formatFraction(decimal) {
  if (decimal == null || decimal === '') return '—';
  const n = parseFloat(decimal);
  if (isNaN(n)) return '—';

  const whole = Math.floor(n);
  const sixteenths = Math.round((n - whole) * 16);

  // Overflow — e.g. 0.999... rounds up to 16/16
  if (sixteenths === 16) return `${whole + 1}"`;
  if (sixteenths === 0) return `${whole}"`;

  const g = gcd(sixteenths, 16);
  const num = sixteenths / g;
  const den = 16 / g;

  return whole > 0 ? `${whole} ${num}/${den}"` : `${num}/${den}"`;
}
